<template>
  <v-img
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    :class="{ 'rotate-180': shouldRotate }"
  />
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true
    },
    rotateInEnglish: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shouldRotate() {
      return this.$i18n.locale === "en" && this.rotateInEnglish;
    }
  }
};
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
</style>
